import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '70vh',
      textAlign: 'center',
      p: 3
    }}>
      <Typography variant="h1" sx={{ fontSize: '4rem', mb: 2 }}>
        404
      </Typography>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Sidan kunde inte hittas
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, maxWidth: '600px' }}>
        Den sida du försöker nå existerar inte. Kontrollera adressen eller gå tillbaka till startsidan.
      </Typography>
      <Button 
        component={Link} 
        to="/" 
        variant="contained" 
        size="large"
        sx={{ px: 4, py: 1.5 }}
      >
        Till startsidan
      </Button>
    </Box>
  );
}

export default NotFound;